import styled from 'styled-components';

type InputNumberUIProps = {
  value?: number;
  onChange?: (value: number) => void;
  onFocus?: () => void;
  inputRef?: any;
  className?: string;
  tabIndex?: number;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
};
const CashierInputNumber = ({ onKeyDown, tabIndex, className, inputRef, onFocus, value = 0, onChange = () => undefined }: InputNumberUIProps) => {
  return (
    <InputNumberStyled
      className={className}
      ref={inputRef}
      value={value}
      tabIndex={tabIndex}
      onFocus={onFocus}
      onChange={(e: any) => onChange(+e.target.value)}
      onKeyPress={(event: any) => {
        if (!/[0-9]/.test(event.key)) {
          event.preventDefault();
        }
      }}
      onKeyDown={onKeyDown}
    />
  );
};

const InputNumberStyled = styled.input``;

export default CashierInputNumber;
